import { hashify } from './arrays';





const latin = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,.';
const cyrillic = 'йцукенгшщзхъфывапролджэячсмитьбю';
const hash = hashify( Object.keys( latin + cyrillic ), 
    index => [(latin + cyrillic)[index], (cyrillic + latin)[index]] );

export function switchKeyboardLayout(word) { 
    return word.split( '' ).map( ch => hash[ch] || ch ).join( '' );
}

export function find(haystack, needle) {
    if (needle === '' || needle === undefined)
        return true;

    const checkString = (haystackToken, needleToken) => 
        needleToken.length > 2 
            ? ~haystackToken.indexOf( needleToken ) 
            : haystackToken.startsWith( needleToken );

    const needleTokens = needle
        .split( ' ' )
        .map( w => w.toLowerCase().trim() )
        .filter( w => !!w );

    return (haystack instanceof Array ? haystack : [haystack])
        .join( ' ' )
        .split( ' ' )
        .map( w => w.toLowerCase().trim() )
        .filter( w => !!w )
        .some( haystackToken => 

            needleTokens.some( needleToken => isNaN( +haystackToken )

                    // haystack token is a string
                    ? checkString( haystackToken, needleToken ) ||
                      checkString( haystackToken, switchKeyboardLayout( needleToken ) )

                    // haystack token is a number
                    : ~(haystackToken + '').indexOf( needleToken ) ) ); 
}


// WEBPACK FOOTER //
// ./src/js/utils/strings.js